// extracted by mini-css-extract-plugin
export default {"root":"CalendarTimeSlotEvent_root__kDTDB","hours":"CalendarTimeSlotEvent_hours__vRTBS","title":"CalendarTimeSlotEvent_title__kj2NA"};